//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

// This license is owned by the email address engineering-admin-photoeditorsdk@bazaarvoice.com

export default {
  api_token: '2WsOspBhYA2DQ8F-r-47mw',
  app_identifiers: [
    '*.curalate.com',
    '*.bazaarvoice.com',
  ],
  available_actions: [],
  domains: ['https://api.photoeditorsdk.com'],
  enterprise_license: false,
  expires_at: null,
  features: [
    'camera',
    'library',
    'export',
    'customassets',
    'whitelabel',
    'adjustment',
    'filter',
    'text',
    'transform',
  ],
  issued_at: 1729796484,
  minimum_sdk_version: '1.0',
  owner: 'Bazaarvoice',
  platform: 'HTML5',
  products: ['pesdk'],
  version: '2.4',
  signature: 'FBCA5y20RbJOIVkBPq393Tnu+6YMilu8M4RqGDCw0R0lcCKlSgPxLtMYTyqxw8WrCILjrzTa5uVoaSAN9mc+RBPrUcHJgyNbGw3Y3jyinP+hgljqi0HqagnnQTREX4kNdImdJnZo88hiwf30yhg5Rczu1YCoxw1BKmorU8mzpMzmBKo6DK2VauWM8d58vw5Cp0wXjKM1qLPXcVTUM+84bLdFr7R9xelNL8p0v9ESvfk1m/oK1j6LQNEfM7A0fO9skKrAktmtfAR9HWsvyTNxG3vkIPhz9IyNxbKG6unxgVXx77XLpkIgtXcgTWEiz2mycYt1wQ9x8HXr3f4PjVqdBcHdoigP/UXwi34iBUA8qTZs7VsC6waihREReXiQZlnmsDUlzPFZepqWczssYB1Q/2h5s+zSEy1ZUG8oKsW3/oyP4Rb1zsNd/Ur6/QnQRL7lfOJT/Q8ueIcIAKU/dRTqxHERWiEBFQRLSv98Cg0wsZzmCjxr+JeRZKqpXRLsq0rppZwsRD7XoAwXUYHl7kxAoTe+9Vuy0nDOy5/44nFLKBhojsQTm4lVFTwCfhhHz6dw/oaX28qnba5mS20Dv5PWUGOe8KP8IU1rmBLIQQWXpl2FRE9nPrVwpuI8f/kb3OJJs4mBmiQf53zTb0/8pSLEIsSEL69qnMdZh9sIn0OzsgQ='
};
